
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tAfaProfile/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tAfaProfile/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tAfaProfile/findPage',
        method: 'post',
      data
    })
}

// 查询波次策略
export const getProfile = (data) => {
  return axios({
    url: '/tAfaProfile/getProfile',
    method: 'post',
    data
  })
}

// 查询波次策略参数
export const getProfilePara = (data) => {
  return axios({
    url: '/tAfaProfile/getProfilePara',
    method: 'post',
    data
  })
}

// 执行波次策略SP
export const execWaveLoadProfile = (data) => {
  return axios({
    url: '/tAfaProfile/execWaveLoadProfile',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tAfaProfile.js